import { withStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import { DataviewStore } from '../../stores/DataviewStore';
import { ReminderList } from './ReminderList';

const dataviewStore = DataviewStore.create({
	id: 'ReminderList',
	orgColumns: [
		'creationTimestamp :datetime 50',
		'branchName',
		'type :Message_Type',
		'subject',
		'text',
		'parameter',
		'isRead :bool 30',
		'id :int 50',
	],
	sorting: {column: 'creationTimestamp'},
});

dataviewStore.addColumnHiderToNamed('DEFAULT', 'text');
dataviewStore.addColumnHiderToNamed('FIXED', 'branchName');
dataviewStore.addColumnHiderToNamed('HIDDEN', 'id');

@observer class _GReminders extends ReminderList {
	name = () => 'GReminders'
}

const styles = theme => ({
});

export const GReminders = withStyles(styles)(_GReminders);
